import { render, staticRenderFns } from "./DatatableHeader.vue?vue&type=template&id=d55f2e10&"
import script from "./DatatableHeader.vue?vue&type=script&lang=js&"
export * from "./DatatableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports